function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  "data-name": "<Pfad>",
  d: "M99.81 113.17l12.85-9.7c3.39-1.74 6.88-2.16 9-.87 3.19 2 30 19.88 32.23 21.47s3.29 6.09.13 10.47-17.69 21.69-23.77 21.46-31.39-1-78.61-48.47S4.13 35 4 29 21.62 8.88 26.1 5.84s9-1.86 10.59.31c1.77 2.47 19.22 29.17 21.14 32.23 1.31 2.09.79 5.56-1 8.88s-9.33 16-9.33 16 5.08 8.87 22.5 26.41c8.3 8.5 29.81 23.5 29.81 23.5z"
});

var SvgLandlineOrCall = function SvgLandlineOrCall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "ICON",
    viewBox: "0 0 160 160",
    "aria-hidden": true
  }, props), _ref);
};

export default SvgLandlineOrCall;